import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { trigger, style, transition, animate } from '@angular/animations';
import { HeaderComponent } from '../header/header.component';
import { SearchDataComponent } from '@features/search/components/search-data/search-data.component';
import { SearchState } from '@features/search/services/search.state';
import { EscapeListenerDirective } from '@shared/directives/escape-listener.directive';
import { VersionBannerComponent } from '@shared/components/version-banner/version-banner.component';
import { FloatingBadgeComponent } from '@features/tipification/components/floating-badge/floating-badge.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    SearchDataComponent,
    EscapeListenerDirective,
    VersionBannerComponent,
    FloatingBadgeComponent
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  animations: [
    trigger('searchPanelAnimation', [
      transition(':enter', [
        style({ transform: 'translateY(-20px)', opacity: 0 }),
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY(0)', opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ transform: 'translateY(-20px)', opacity: 0 }))
      ])
    ]),
    trigger('backdropAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('200ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class MainLayoutComponent {
  readonly searchState = inject(SearchState);
}
